/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Typography, Button } from '@mui/material';
import { BigModal } from './BigModal';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const btnStyle = {
  mx: 'auto',
  mt: 5,
  width: 100,
  color: '#84d8c5',
  border: '1px solid #84d8c5',
  '&:hover': {
    color: '#FFF',
    border: '1px solid #84d8c5',
    bgcolor: 'rgb(132, 216, 197, 0.2) !important',
  },
  '&:hover .MuiSvgIcon-root': {
    fill: '#FFF !important',
  },
};

export const SuccessModal = (props) => {
  return (
    <BigModal open={props.open} onClose={props.onClose}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <CheckCircleIcon sx={{ fontSize: '5rem', mx: 'auto' }} />
        <Typography
          id="modal-modal-title"
          variant="h4"
          component="h2"
          sx={{ fontWeight: 800, textAlign: 'center' }}
        >
          Success!
        </Typography>
        <Typography
          id="modal-modal-description"
          sx={{ mt: 1, textAlign: 'center' }}
        >
          {props.desc}
        </Typography>
        <Button sx={btnStyle} onClick={props.close}>
          Close
        </Button>
      </div>
    </BigModal>
  );
};
